module.exports = __webpack_public_path__ + "assets/img/remove.f05284ce.svg";